import type { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import type { CurrentProfileState, ProfileState } from './types';
import { getProfileAction, updateProfileAction, getCurrentProfileAction } from './actions';

/**
 * Legacy: needs to remove
 */
export function getProfileBuilder(builder: ActionReducerMapBuilder<ProfileState>) {
  builder.addCase(getProfileAction.pending, (state) => {
    state.isProfileFetching = true;
  });
  builder.addCase(getProfileAction.fulfilled, (state, action) => {
    state.isProfileFetching = false;
    state.profile = { ...state.profile, ...action.payload };
  });
  builder.addCase(getProfileAction.rejected, (state) => {
    state.isProfileFetching = false;
  });
}

/**
 * Legacy: needs to remove
 */
export function updateProfileBuilder(builder: ActionReducerMapBuilder<ProfileState>) {
  builder.addCase(updateProfileAction.pending, (state) => {
    state.isProfileUpdating = true;
  });
  builder.addCase(updateProfileAction.fulfilled, (state, action) => {
    state.isProfileUpdating = false;
    state.profile = { ...state.profile, ...action.payload };
  });
  builder.addCase(updateProfileAction.rejected, (state) => {
    state.isProfileUpdating = false;
  });
}

export function getCurrentProfileBuilder(builder: ActionReducerMapBuilder<CurrentProfileState>) {
  builder.addCase(getCurrentProfileAction.pending, (state) => {
    state.isProfileFetching = true;
  });
  builder.addCase(getCurrentProfileAction.fulfilled, (state, action) => {
    state.isProfileFetching = false;
    state.profile = action.payload;
    state.userRole = action.payload.role;
  });
  builder.addCase(getCurrentProfileAction.rejected, (state) => {
    state.isProfileFetching = false;
  });
}
